import Vue from 'vue';
import { App, plugin } from '@inertiajs/inertia-vue';
import { InertiaProgress } from '@inertiajs/progress';
import VueMeta from 'vue-meta';
import PortalVue from 'portal-vue';
import NamedRoutes from './plugins/named-routes.js';
import i18n from './plugins/i18n.js';
import Axios from './plugins/axios.js';
import ActivixUI from './plugins/activix-ui.js';
import './plugins/vue-notification.js';

// Don't warn about using the dev version of Vue in development.
Vue.config.productionTip = process.env.NODE_ENV === 'production';

Vue.use(plugin);
Vue.use(VueMeta);
Vue.use(PortalVue);
Vue.use(Axios, { locale: i18n.locale });
Vue.use(NamedRoutes);
Vue.use(ActivixUI);

InertiaProgress.init();

const app = document.getElementById('app');

new Vue({
    i18n,
    render: h => h(App, {
        props: {
            initialPage: JSON.parse(app.dataset.page),
            resolveComponent: name => require(`./pages/${name}`).default,
        },
    }),
}).$mount(app);
